import React from 'react';
import { FloatButton } from 'antd';
import { NavLink } from "react-router-dom";

function FooterCopyright() {
  return (
    <div style={{
      background: '#1f2937',
      padding: '20px 0',
      borderTop: '1px solid #374151'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        <div style={{
          color: '#9ca3af',
          fontSize: '14px'
        }}>
          ©2024 OkBrahmin. All rights reserved.
        </div>
        
        <nav>
          <ul style={{
            display: 'flex',
            listStyle: 'none',
            margin: 0,
            padding: 0,
            gap: '24px'
          }}>
            <li>
              <NavLink 
                to="/privacy"
                style={{
                  color: '#d1d5db',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#fbbf24'}
                onMouseLeave={(e) => e.target.style.color = '#d1d5db'}
              >
                Privacy
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/terms"
                style={{
                  color: '#d1d5db',
                  textDecoration: 'none',
                  fontSize: '14px',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#fbbf24'}
                onMouseLeave={(e) => e.target.style.color = '#d1d5db'}
              >
                Terms
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
      
      <FloatButton.BackTop 
        style={{
          background: 'linear-gradient(135deg, #667eea, #764ba2)',
          border: 'none'
        }}
      />
    </div>
  );
}

export default FooterCopyright;